import EntityManageView from 'Components/EntityManageView';
import { actions } from 'ducks/equipment';
import React from 'react';
import { useSelector } from 'react-redux';
import { metadataFields } from 'utils/forms/utils';
import validators from 'utils/forms/validators';
import { getEquipmentMetadata } from 'utils/getMetadata.js';

const Component = props => {
    const currentUser = useSelector(state => state.users.models[state.auth.currentUserId]);
    const model = useSelector(state => state.equipments.models[state.drawerView.entityId]);
    const submitting = useSelector(state => state.equipments.submitting);
    const equipmentCategory = useSelector(state => state.equipmentCategories.models[model.equipment_category]);
    const metadata = getEquipmentMetadata(equipmentCategory);

    const stateProps = { currentUser, metadata, model, submitting };

    const stateActions = ({
        create: actions.useCreate(),
        update: actions.useUpdate()
    });

    const formSchema = [
        {
            type: 'text',
            label: 'Name\x2a',
            name: 'name',
            validate: [validators.required]
        },
        {
            type: 'textArea',
            label: 'Description',
            name: 'description'
        },
        ...metadataFields(metadata, model)
    ];

    if (model.usable && currentUser.superuser) {
        formSchema.push(
            {
                type: 'checkBox',
                label: 'Usable Equipment?',
                name: 'usable'
            });
    }

    return (
        <EntityManageView
            formInitialValues={model}
            formSchema={formSchema}
            label="Edit Equipment"
            {...stateProps}
            {...stateActions}
            {...props}
        />
    );
};

export default Component;
